@use "variables" as *;

.cancelButton {
  color: indianred;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.resendButton {
  font-size: $fontSize-s;
}

.subtitle {
  font-size: $fontSize-s;
  font-weight: normal;
  margin-bottom: $spacing-s;
}

.countdown {
  font-size: $fontSize-s;
  font-weight: bold;
  align-self: center;
  text-align: center;
  font-variant: tabular-nums;
}
